import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
let lang = localStorage.getItem('lang')
let language
// if (lang === 'English') {
//   language = 'en'
// } else if (lang === 'zh_HK') {
//   language = 'zh'
// } else if (lang === 'br') {
//   language = 'br'
// }

if (!lang) {
  lang = window.config.VUE_APP_DEFAULT_LANG
}

let _lang = window.config.VUE_APP_LANG_LIST.split(';').map(x => {
  return {
    name: x.split(':')[0],
    langcode: x.split(':')[1],
    xReqLanguage: x.split(':')[2]
  }
}).find(x => x.langcode === lang)

if (!_lang) {
  // localStorage.setItem('lang', 'zh_HK')
  // localStorage.setItem('lang', 'English') // default language is english
  localStorage.setItem('lang', window.config.VUE_APP_DEFAULT_LANG)
  language = window.config.VUE_APP_DEFAULT_LANG
} else {
  language = _lang.langcode
}

const i18n = new VueI18n({
  locale: language,
  messages: {
    'zh': require('../lang/zh'),
    'en': require('../lang/en'),
    'br': require('../lang/br')
  }
})
window.i18n = i18n
export default i18n



// WEBPACK FOOTER //
// ./src/assets/js/i18n.js